<!-- Loading -->
<span *ngIf="phase === 'loading'" class="sig-badge sig-none" title="Verifying signature…">
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2">
    <path d="M12 2 4 5v6c0 5 3.4 8.7 8 9 4.6-.3 8-4 8-9V5z" />
  </svg>
</span>

<!-- Error -->
<span *ngIf="phase === 'error'" class="sig-badge sig-warning" title="Could not verify signature">
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2">
    <path d="M12 2 4 5v6c0 5 3.4 8.7 8 9 4.6-.3 8-4 8-9V5z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="16.5" x2="12" y2="16.51" />
  </svg>
</span>

<!-- No signature: shown but inert, matching the reference badge's disabled/grey state -->
<span
  *ngIf="phase === 'done' && !hasSignature"
  class="sig-badge sig-none"
  title="No digital signature"
>
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2">
    <path d="M12 2 4 5v6c0 5 3.4 8.7 8 9 4.6-.3 8-4 8-9V5z" />
  </svg>
</span>

<!-- Has a signature: clickable, opens the details dialog -->
<button
  *ngIf="phase === 'done' && hasSignature"
  type="button"
  class="sig-badge sig-btn"
  [ngClass]="{
    'sig-valid': result?.overallStatus === 'VALID',
    'sig-warning': result?.overallStatus === 'WARNING',
    'sig-invalid': result?.overallStatus === 'INVALID'
  }"
  [title]="
    result?.overallStatus === 'VALID' ? 'Valid digital signature' :
    result?.overallStatus === 'WARNING' ? 'Signature intact, but not fully trusted' :
    'Invalid signature — document may be altered'
  "
  (click)="onClick()"
>
  <svg *ngIf="result?.overallStatus === 'VALID'" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2">
    <path d="M12 2 4 5v6c0 5 3.4 8.7 8 9 4.6-.3 8-4 8-9V5z" />
    <path d="m9 12 2 2 4-4" />
  </svg>
  <svg *ngIf="result?.overallStatus === 'WARNING'" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2">
    <path d="M12 2 4 5v6c0 5 3.4 8.7 8 9 4.6-.3 8-4 8-9V5z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="16.5" x2="12" y2="16.51" />
  </svg>
  <svg *ngIf="result?.overallStatus === 'INVALID'" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2">
    <path d="M12 2 4 5v6c0 5 3.4 8.7 8 9 4.6-.3 8-4 8-9V5z" />
    <line x1="9.5" y1="9.5" x2="14.5" y2="14.5" />
    <line x1="14.5" y1="9.5" x2="9.5" y2="14.5" />
  </svg>
</button>
